export const initialState = null;

export const reducer = (state, action) => {
    if(action.type === "Notification"){
        return action.payload;
    }
    return state;
}

